import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Chip,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Skeleton,
} from '@mui/material';

function formatDate(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function formatDuration(startIso, endIso) {
  if (!startIso || !endIso) return '—';
  const diffMs = new Date(endIso) - new Date(startIso);
  const totalMinutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours > 0) return `${hours}h ${minutes}min`;
  return `${minutes} min`;
}

const HEADERS = [
  { id: 'cycleNumber', label: 'Cycle' },
  { id: 'status', label: 'Statut' },
  { id: 'startedAt', label: 'Démarré le' },
  { id: 'completedAt', label: 'Terminé le' },
  { id: 'duration', label: 'Durée' },
  { id: 'totalEnterprisesProcessed', label: 'Entreprises' },
  { id: 'totalEmailsSent', label: 'Emails envoyés' },
];

export default function CyclesTable({ rows, loading }) {
  return (
    <Paper elevation={2} sx={{ mb: 3 }}>
      <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Typography variant="subtitle1" fontWeight="bold">
          Historique des cycles de notification
        </Typography>
      </Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: 'grey.50' }}>
              {HEADERS.map((h) => (
                <TableCell key={h.id} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array.from({ length: 5 }).map((_, i) => (
                  <TableRow key={i}>
                    {HEADERS.map((h) => (
                      <TableCell key={h.id}>
                        <Skeleton width="80%" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              : rows.length === 0
              ? (
                <TableRow>
                  <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 4 }}>
                    <Typography color="text.secondary" variant="body2">
                      Aucun cycle enregistré
                    </Typography>
                  </TableCell>
                </TableRow>
              )
              : rows.map((cycle) => (
                  <TableRow key={cycle.id} hover>
                    <TableCell>
                      <Typography variant="body2" fontWeight="bold">
                        #{cycle.cycleNumber}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {cycle.completedAt ? (
                        <Chip label="Terminé" color="success" size="small" />
                      ) : (
                        <Chip label="En cours" color="warning" size="small" />
                      )}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {formatDate(cycle.startedAt)}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                      {cycle.completedAt ? formatDate(cycle.completedAt) : '—'}
                    </TableCell>
                    <TableCell>{formatDuration(cycle.startedAt, cycle.completedAt)}</TableCell>
                    <TableCell>{cycle.totalEnterprisesProcessed}</TableCell>
                    <TableCell>{cycle.totalEmailsSent}</TableCell>
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
